<template>
  <el-table-column
    prop="ntax_partner.custom_name"
    label="Egyedi NTAX név"
    sortable="custom"
    min-width="200"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      <span
        v-if="scope.row.ntax_partner"
      >
        {{ scope.row.ntax_partner.custom_name }}
      </span>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'ntax_partner.custom_name',
};
</script>
